
import React from "react";
import { SoftwareDev } from "./components/software_page";
import { BackToTop } from './components/BackToTop'
import { WhatsAppFloat } from './components/WhatsAppFloat'
import {Navigation} from "./components/navigation";

const phoneNumber = "1234567890"; // Replace with your actual phone number


export default function SoftwareDevelopment(){
    return(
        <main className="min-h-screen font-poppins flex flex-col" >
            <Navigation/>
            <SoftwareDev />
            <WhatsAppFloat phoneNumber={phoneNumber} />
            <BackToTop />
        </main>
    )
}